import { gql } from '@apollo/client'

export const DEMANDE_UPDATE = gql`
  mutation DemandeUpdate($id: bigint!, $data: d4_demande_set_input!) {
    demande: update_d4_demande_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
      epingle
      description
      etatdemande
      datecloturedefinitive
      datecloturepard4
      urgence
      datedernierimportmailatraiter
      suivics
      dossierpermanent
    }
  }
`

/**
 * context: copropriete_id || personne_id
 * batiment: batiment_id || null (Géneral)
 * equipement: equipement_id
 * kanban: kanban_id
 * demande: texte de la demaine eg: A > VMC > Bruyante à cause de vibrations > {demande}
 */

export const DEMANDE_INSERT = gql`
  mutation DemandeInsert(
    $equipementCoproId: Int
    $equipementBatimentId: Int
    $coproprieteId: Int!
    $typeEquipementId: Int!
    $kanban: Int
    $demande: String!
    $equipementLibelle: String!
    $emetteurId: Int
    $gestionnairequidoitrappelerId: Int
    $dtype: String!
  ) {
    demande: createDemande(
      data: {
        equipementCoproId: $equipementCoproId
        equipementBatimentId: $equipementBatimentId
        coproprieteId: $coproprieteId
        typeEquipementId: $typeEquipementId
        kanban: $kanban
        demande: $demande
        equipementLibelle: $equipementLibelle
        emetteurId: $emetteurId
        gestionnairequidoitrappelerId: $gestionnairequidoitrappelerId
        dtype: $dtype
      }
    ) {
      id
      copropriete_id
      __typename
    }
  }
`

export const EQUIPEMENT_INSERT_MUTATION = gql`
  mutation EquipementInsert(
    $equipementCoproId: bigint
    $equipementBatimentId: bigint
    $typeEquipementId: bigint!
    $equipementLibelle: String!
    $demandeId: bigint!
  ) {
    equipement: insert_d4_equipement_one(
      object: {
        libelle: $equipementLibelle
        typeequipement_id: $typeEquipementId
        copropriete_id: $equipementCoproId
        batiment_id: $equipementBatimentId
        demandes: {
          data: { id: $demandeId }
          on_conflict: { constraint: idx_16567_primary, update_columns: [equipement_id] }
        }
      }
    ) {
      id
      # libelle
      # typeequipement_id
      # typeequipement {
      #   typeequipement
      #   id
      # }
      # demande {
      #   id
      #   equipement_id
      # }
    }
  }
`
